


















































import { Component, Prop, Vue } from "vue-property-decorator";
import { GmAccount } from "@/req/settlement"
import { gameList } from "@/req/gameManage";
@Component({
  components: {},
})
export default class Home extends Vue {
  public createTime = "";
  public baseList: any = {
    orderId: "",
    gameId: "",
    gmName: "",
    settleChannel: "",
  };
  public gmList = [];
  public channelList = [
    {
      id: 1,
      name: "余额"
    },
    {
      id: 2,
      name: "现金"
    }
  ]
  public mounted() {
    this.getGmList();
  }
  public async getGmList() {
    const res = await GmAccount({
      token: this.$fn.cookies.getToken("token"),
    })
    if (res.code == 0) {
      this.gmList = res.data;
    }
  }
  public save(state) {
    this.$emit("returnList", this.baseList);
  }
}
